import React from 'react';
import OMInputField from '../OMInputField/OMInputField';
import * as styles from './OMInputWithLable.scss';

const OMInputWithLable = (properties) => {
  const required = (properties.required) ? (<span className="required">*</span>) : null;

  return (
    <div className={properties.className}>
      <div className={styles.label}>{properties.title}{required}</div>
      <OMInputField
        {...properties.field}
        name={properties.name}
        type={properties.type}
        placeholder={properties.placeholder}
        title={properties.title}
        className={properties.className}
        isRtl={properties.isRtl}
      />
    </div>
  );
};

export default OMInputWithLable;
